import React, { Component } from "react";
import _ from 'i18n';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend, ResponsiveContainer
} from "recharts";
import {CommonLoader} from "../../../common/CommonLoader";
import {formatAmount} from "../../../../services/utils";
import RegistrationCAFilter from "../../../Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter";
import { nbrInscrits } from "./data";
import { connect } from "react-redux";


class EventLineChartFormat extends Component {

  translateData = (preparedData) => {
    const {language} = this.props;
    if(language != 'fr'){
      preparedData.forEach(element => {
        element.name = _(element.name);
      })
    }
    return preparedData;
  }

  getDaysOfMonthFromString(monthYearArray) {
    const daysArray = [];

    monthYearArray.forEach(monthYear => {
        const [year, month] = monthYear.split('-').map(Number);
        
        const daysInMonth = new Date(year, month, 0).getDate();

        for (let i = 1; i <= daysInMonth; i++) {
            const day = String(i).padStart(2, '0');
            const monthFormatted = String(month).padStart(2, '0');
            daysArray.push(`${day}/${monthFormatted}`);
        }
    });

    return daysArray;
  }

  getYearsArray() {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];

    for (let year = 2018; year <= currentYear; year++) {
        yearsArray.push(year);
    }

    return yearsArray;
  }


  prepareData = () => {
    const { data, type, frequency, period } = this.props;

    const transformedData = [];
    const months = ["Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"];
    const daysOfMonth = this.getDaysOfMonthFromString(period);
    const years = this.getYearsArray();

    let monthOrDaysOrYears = [];

    // switch (frequency) {
    //   case 'MONTHLY':
    //     monthOrDaysOrYears = months;
    //     break;
    //   case 'DAILY':
    //     monthOrDaysOrYears = daysOfMonth;
    //     break;
    //   case 'YEARLY':
    //     monthOrDaysOrYears = years;
    //     break;
    //   default:
    //     break;
    // }

    

    // Filter out years, months, or days that don't have data
    Object.keys(data).forEach(entity => {
      if(entity.length > 0) {
        const years = data[entity].map((element) => element.name);
        monthOrDaysOrYears = [...monthOrDaysOrYears, ...years];
      }
    });
    
    monthOrDaysOrYears = [...new Set(monthOrDaysOrYears)];

    // Loop through the months/days/years
    monthOrDaysOrYears.forEach((monthOrDayOrYear, index) => {
      const monthData = { "name": monthOrDayOrYear, "total": 0 };

      // Loop through each entity (Utopix, KA, Lexalert, etc.)
      Object.keys(data).forEach(entity => {
        console.log("=======", entity.length === 0);
        
        if(entity.length === 0) return;
        // Initialize entityTotal
        let entityTotal = 0;

        // Check if the data for the specific year or time period exists for the current entity
        if (data[entity] && data[entity][index]) {
          // If data exists, sum the values for that month/day/year
          entityTotal = 
            data[entity][index].formations +
            data[entity][index].cycles +
            data[entity][index].cycles_essential +
            data[entity][index].saisons +
            data[entity][index].monthly_premium +
            data[entity][index].yearly_premium +
            data[entity][index].congrès;
        }
        monthData[entity] = type === 'CA' ? entityTotal / 100 : entityTotal;

        // Add the total to the monthData object for the current entity
        monthData['total'] += type === 'CA' ? entityTotal / 100 : entityTotal;
      });

      // Only push the monthData if it contains at least one entity's data
      if (Object.keys(monthData).length > 1) {
        transformedData.push(monthData);
      }
    });
    
    // let copiedData = transformedData.map(element => Object.assign({}, element));
    let preparedData = transformedData.map((element, index) => {
      element = type === 'CA' ? element : element;
      return element;
    })
    
    return this.translateData(preparedData);
  }

  getCurrentYearMonth() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}`;
  }

  render() {

    const { data, chartLinesToShowSeason, fetching, type, updateChartType, seasonsToShow, eventStatsFilter, frequency, period, showAccumulateEventStats, formatAccumulateData, formatAccumulateCAData } = this.props;

    const transformedData = [];
    const months = ["Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"];

    months.forEach((month, index) => {
      const monthData = { "name": month };

      // Loop through each entity (Utopix, KA, Lexalert, etc.)
      Object.keys(data).forEach(entity => {
          if (entity.length === 0) return;
          // Initialize entityTotal
          let entityTotal = 0;

          // Check if the entity has data for the current month
          if (data[entity][index]) {
              // If data exists, sum the values for that month
              entityTotal = 
              data[entity][index].formations +
              data[entity][index].cycles +
              data[entity][index].cycles_essential +
              data[entity][index].saisons +
              data[entity][index].monthly_premium +
              data[entity][index].yearly_premium +
              data[entity][index].congrès;
          }

          // Add the total to the monthData object for the current entity
          monthData[entity] = entityTotal;
      });

      // Push the monthData for the current month
      transformedData.push(monthData);
    });

    // const days = this.getDaysOfMonthFromString(['2025-01']);

    const prepareData = showAccumulateEventStats ? (type === 'CA' ? formatAccumulateCAData.map(item => {
      let newItem = {};
      for (let [key, value] of Object.entries(item)) {
        newItem[key] = key === 'name' ? value : value / 100;
      }
      return newItem;
    }) : formatAccumulateData) : this.prepareData();
    const transformedPrepareData = [];

    const currentMonth = new Date().getMonth();
    const currenDay = new Date().getDate();

    if(eventStatsFilter.year.length == 1 && eventStatsFilter.year[0] == new Date().getFullYear()){
      if(frequency == 'MONTHLY'){
        for (let index = 0; index <= currentMonth; index++) {
          transformedPrepareData.push(prepareData[index]);
        }
      }
      else if (frequency == 'DAILY' && period.length > 0 && period[0] == this.getCurrentYearMonth()) {
        for (let index = 0; index < currenDay; index++) {
          transformedPrepareData.push(prepareData[index]);
        }
      }
      else {
        prepareData.forEach(element => {
          transformedPrepareData.push(element);
        });
      }
    } else {
      prepareData.forEach(element => {
        transformedPrepareData.push(element);
      });
    }
    
    return (
      <React.Fragment>
      <div style={{width: '100%'}}>
            <RegistrationCAFilter type={type} updateType={updateChartType}/>
      </div>
      <div>
        {
          fetching === true ?
            <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"}/> :
            (
              transformedData.length === 0 ?
                <div className={'flex items-center flex-column justify-center'} style={{minHeight : '300px'}}>
                  <div className={'chart-registrant-number-label mb-3'} style={{textTransform : 'none'}}>{type === 'REGISTRATION' ? _('NO_REGISTRATIONS') : _('NO_CA')}</div>
                </div>
                :
                <ResponsiveContainer width={'100%'} height={300}>
                  <LineChart
                    data={transformedPrepareData}
                    margin={{
                      top: 10,
                      right: 30,
                    }}
                    style={{
                      fontSize: '12px',
                      fontFamily: 'Roboto',
                      fontStyle: 'normal',
                      fontWeight: 400
                    }}
                  >
                    <CartesianGrid stroke="#D8DDE2" vertical={false}
                                   strokeDasharray="4"/>
                    <XAxis dataKey="name" tickMargin={10} axisLine={false}
                           tickLine={false} tick={{fill: '#6D7F92'}}/>
                    <YAxis tickMargin={10} axisLine={false} tickLine={false}
                           tick={{fill: '#6D7F92'}} allowDecimals={false}/>
                    <Tooltip contentStyle={{'borderRadius' : '5px', 'position': 'relative', 'top': '-90px'}} itemStyle={{textTransform : "capitalize"}} 
                             formatter={type === 'CA' ? (value) => formatAmount(value, false) : (value) => value}
                    />

                    {
                      chartLinesToShowSeason.map(({legend, color, lineName}, index) => {
                        return (
                          <Line
                            key={index}
                            dataKey={lineName}
                            label={legend}
                            stroke={color}
                            activeDot={{r: 8}}
                            type='linear'
                            dot={{stroke: color, strokeWidth: 6}}
                          />
                        )
                      })
                    }
                    <Line
                      key={'total'}
                      dataKey={"total"}
                      label={"Total"}
                      stroke={"#000000"}
                      activeDot={{r: 8}}
                      type='linear'
                      dot={{stroke: "#000000", strokeWidth: 6}}
                    />
                  </LineChart>
                </ResponsiveContainer>
            )

        }
      </div>
    </React.Fragment>
    );
  }
}


const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

export default connect(mapStateToProps)(EventLineChartFormat);


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartFormat.js